import React, { useEffect } from 'react'
import Image from 'cwp-components/placeholders/Image'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'
import { Link } from 'react-router-dom'

const FeaturedArticle = () => {
  const { featuredArticle, loadFeaturedArticle } = useArticleTemplate()
  useEffect(() => {
    loadFeaturedArticle()
  }, [loadFeaturedArticle])

  return (
    <div className='banner p-10 lg:p-[80px]'>
      <div className='py-5 md:py-0'>
        <div
          className='flex flex-col md:flex-row justify-between
'
        >
          <div className='md:w-5/12 mb-10'>
            <h3 className='mb-5 text-[16px] md:text-[24px] lg:text-[24px] text-white'>
              Featured Article
            </h3>
            <p className='mb-5 text-[18px]  lg:text-[32px]  font-bold '>
              {featuredArticle.title}
            </p>
            <Link to={`/articles/${featuredArticle.id}`} className='underline'>
              Read more
            </Link>
          </div>
          <div className='md:w-6/12'>
            {featuredArticle.cover_image ? (
              <img
                src={featuredArticle.cover_image}
                alt='Featured Article'
                className='w-full h-auto'
              />
            ) : (
              <Image
                height='300px'
                background='#101828'
                className='flex items-center justify-center'
              >
                Image
              </Image>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeaturedArticle
